import { render, staticRenderFns } from "./OrderTransaction.vue?vue&type=template&id=7d82b94b&scoped=true&"
import script from "./OrderTransaction.vue?vue&type=script&lang=js&"
export * from "./OrderTransaction.vue?vue&type=script&lang=js&"
import style0 from "./OrderTransaction.vue?vue&type=style&index=0&id=7d82b94b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d82b94b",
  null
  
)

export default component.exports